import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './Components/Header.jsx';
import ModernFooter from './Components/ModernFooter.jsx';
import HomePage from './pages/HomePage.jsx';
import Consulting from './pages/Consulting.jsx';
import Outsourcing from './pages/Outsourcing.jsx';
import ProductPage from './pages/ProductPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import Contact from './pages/ContactPage.jsx';
import CareersPage from './pages/CareersPage.jsx';

function App() {
  return (
    <BrowserRouter basename="/">
      <div className="bg-blue-50 min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/outsourcing" element={<Outsourcing />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
        <ModernFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;
